import React from 'react'
import {
    Table,
    Button, Container,
    Row, Col, Label,
} from 'reactstrap'
import '../css/QuoteViewController.css'
import DateTextField from '../view/DateTextField'
import DropDownTextField from '../view/DropDownTextField'
import { downloadPurchaseOrderWithId } from '../model/request/pdf'
import {
    updatePurchaseOrder,
    searchPurchaseOrders,
} from '../model/request/purchase_order'
import { JustDate } from '../model/JustDate'
import { Account } from '../model/Account'
import { formatAsDollarValue, moneyText, dateOffsetText } from '../model/Formatting'

class PurchaseOrderStateChangingViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        const account = Account.fromCookieAndLocalStorage()
        this.state = {
            'account': account,
            'purchase_orders': [],
            'query_date_min': props.query_date_min || null,
            'query_date_max': props.query_date_max || null,
        }
    }

    componentDidMount() {
        this.updateTable()
    }

    updateTable() {
        this.props.turnOnLoader()

        function compareNullDates(lhs, rhs) {
            if (lhs && rhs) {
                const lvalue = lhs.toSingleNumber()
                const rvalue = rhs.toSingleNumber()

                if (lvalue !== rvalue) {
                    return rvalue - lvalue
                }
            } else if (lhs) {
                return 1
            } else if (rhs) {
                return -1
            }
            return 0
        }

        const min = {}
        min['min_' + this.props.query_date_varname] = this.state.query_date_min

        const max = {}
        max['max_' + this.props.query_date_varname] = this.state.query_date_max

        searchPurchaseOrders(
            {
                ...(this.state.query_date_min ? min : {}),
                ...(this.state.query_date_max ? max : {}),
                ...this.props.filter
            }
        ).then(
            (purchase_orders) => {
                purchase_orders = purchase_orders.sort((lhs, rhs) => {
                    const delivery_date = compareNullDates(lhs.delivery_date, rhs.delivery_date)
                    if (delivery_date !== 0) {
                        return delivery_date
                    }

                    const order_date = compareNullDates(lhs.order_date, rhs.order_date)
                    if (order_date !== 0) {
                        return order_date
                    }

                    const expected_delivery_date = compareNullDates(
                        lhs.expected_delivery_date, rhs.expected_delivery_date,
                    )
                    if (expected_delivery_date !== 0) {
                        return expected_delivery_date
                    }

                    const expected_order_date = compareNullDates(
                        lhs.expected_order_date, rhs.expected_order_date,
                    )
                    if (expected_order_date !== 0) {
                        return expected_order_date
                    }

                    return 0
                })
                this.setState({
                    'purchase_orders': purchase_orders,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    // MARK: View

    renderLabelAndView(label, view) {
        return <Container>
            <Row>
                <Col><Label
                    style={{
                        'fontSize': '18pt',
                        'fontWeight': '300',
                    }}
                >{label}</Label></Col>
            </Row>
            <Row>
                <Col>{view}</Col>
            </Row>
        </Container>
    }

    renderInputWithSuggestions(value, suggestion, maxSuggestionsShown=10, onUpdate) {
        if (maxSuggestionsShown > 0) {
            suggestion = suggestion.slice(0, maxSuggestionsShown)
        }

        return <DropDownTextField
            alwaysDisplayValues={true}
            value={value}
            values={suggestion}
            onChange={(e) => {
                onUpdate(e.target.value)
            }}
            onClickRow={(value, valueIndex) => {
                onUpdate(value)
            }} />
    }

    render() {
        return (
            <Container>
            <Row>
                <Col>
                    <Label
                        style={{
                            'fontSize': '20pt',
                            'fontWeight': '400',
                        }}
                    >{this.props.title || ''}</Label>
                </Col>
            </Row>
            <Row>
                <Col>
                    {this.renderLabelAndView(
                        this.props.query_date_label + ' Min Date',
                        <DateTextField
                            style={{
                                'display': 'inline-block',
                            }}
                            showModal={this.props.showModal}
                            closeModal={this.props.closeModal}
                            value={this.state.query_date_min || undefined}
                            onChange={(d) => {
                                this.setState({
                                    'query_date_min': d,
                                })
                            }}
                            />
                    )}
                </Col>
                <Col>
                    {this.renderLabelAndView(
                        this.props.query_date_label + ' Max Date',
                        <DateTextField
                            style={{
                                'display': 'inline-block',
                            }}
                            showModal={this.props.showModal}
                            closeModal={this.props.closeModal}
                            value={this.state.query_date_max || undefined}
                            onChange={(d) => {
                                this.setState({
                                    'query_date_max': d,
                                })
                            }}
                            />
                    )}
                </Col>
            </Row>
            <Row
                style={{
                    'marginTop': '16px',
                }}
            >
                <Col>
                    <Container>
                        <Button
                            onClick={(e) => {
                                this.updateTable()
                            }}
                        >Search</Button>
                    </Container>
                </Col>
            </Row>
            <Row
                style={{
                    'marginTop': '16px',
                }}
            ><Col><div style={{'overflowX': 'auto'}}><Table>
                <thead>
                    <tr>
                        <th className="text-center label-weight"
                            style={{'minWidth': '200px'}}>PO Number</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '200px'}}>Vendor Name</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '200px'}}>Ordered By</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '200px'}}>Ship Via</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '200px'}}>Order Date</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '200px'}}>{this.props.delivery_date_label || 'Delivery Date'}</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '120px'}}>Sub Total</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '250px'}}>Description</th>
                        {this.props.update_date_label
                            ?  <th className="text-center label-weight"
                                style={{'minWidth': '200px'}}>{this.props.update_date_label}</th>
                            : <></>
                        }
                    </tr>
                </thead>
                <tbody>
                    {this.state.purchase_orders.map((po) => {
                        return <tr>
                            <td style={{
                                'textAlign': 'center',
                            }}>
                                <Label><a href={'/purchaseorder/' + po.id}>
                                    {1_000_000 + Number.parseInt(po.id)}
                                </a></Label>
                            </td>
                            <td style={{
                                'textAlign': 'center',
                            }}>
                                <Label>{po.vendor_name}</Label>
                            </td>
                            <td style={{
                                'textAlign': 'center',
                            }}>
                                <Label>{po.order_by}</Label>
                            </td>
                            <td style={{
                                'textAlign': 'center',
                            }}>
                                <Label>{po.ship_via}</Label>
                            </td>
                            <td style={{
                                'textAlign': 'center',
                            }}>
                                <Label>{(() => {
                                    const date = po.order_date || po.expected_order_date
                                    return <span text={dateOffsetText(date)}>{date.formatDate('mmmm d, yyyy')}</span>
                                })()}</Label>
                            </td>
                            <td style={{
                                'textAlign': 'center',
                            }}>
                                <Label>{(() => {
                                    const date = po.delivery_date || po.expected_delivery_date
                                    return <span text={dateOffsetText(date)}>{date.formatDate('mmmm d, yyyy')}</span>
                                })()}</Label>
                            </td>
                            <td style={{
                                'textAlign': 'right',
                            }}>
                                <Label><span text={moneyText(po.sub_total)}>{formatAsDollarValue(po.sub_total)}</span></Label>
                            </td>
                            <td style={{
                                'textAlign': 'center',
                                'overflowX': 'auto',
                                'whiteSpace': 'nowrap',
                                'maxWidth': '250px',
                            }}>
                                <Label>{po.items.map((item) => item.description).join(', ')}</Label>
                            </td>
                            {this.props.update_date
                                ? <>
                            <td>
                                <input type="checkbox" checked={po[this.props.update_date]}
                                style={{
                                    'display': 'inline-block',
                                }}
                                onChange={(e) => {
                                    if (!po[this.props.update_date]) {
                                        po[this.props.update_date] = new JustDate()
                                    } else {
                                        po[this.props.update_date] = undefined
                                    }

                                    this.setState({})
                                }} />
                                <div style={{
                                    'display': 'inline-block',
                                    'width': 'min(600px, 100% - 22px)',
                                    'marginLeft': '8px',
                                }}>
                                <DateTextField
                                    style={{
                                        'display': 'inline-block',
                                    }}
                                    showModal={this.props.showModal}
                                    closeModal={this.props.closeModal}
                                    value={po[this.props.update_date] || undefined}
                                    onChange={(d) => {
                                        po[this.props.update_date] = d
                                        this.setState({})
                                    }}
                                    />
                                </div>
                            </td>
                            <td>
                                <Button
                                    color='success'
                                    onClick={(e) => {
                                        this.props.turnOnLoader()
                                        const purchaseOrder = {
                                            'id': po.id,
                                        }
                                        purchaseOrder[this.props.update_date] = po[this.props.update_date]
                                        updatePurchaseOrder(purchaseOrder).then(
                                            (purchase_order) => {
                                                this.props.turnOffLoader()
                                            },
                                            (error) => {
                                                this.props.showError(error)
                                                this.props.turnOffLoader()
                                            }
                                        )
                                    }}
                                    >Save</Button>
                            </td>
                                </>
                                :<></>
                            }
                            <td
                                style={{
                                    'minWidth': '150px',
                                }}
                            >
                                <Button
                                    onClick={(e) => {
                                        downloadPurchaseOrderWithId(po.id)
                                    }}
                                    >Download PDF</Button>
                            </td>
                        </tr>
                    })}
                </tbody>
            </Table></div></Col></Row>
            </Container>
        )
    }
}

export default PurchaseOrderStateChangingViewController

